/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import QuestionnairesidQuestionnaireQuestionsAttributes from './QuestionnairesidQuestionnaireQuestionsAttributes';

/**
 * The QuestionnairesidQuestionnaire model module.
 * @module model/QuestionnairesidQuestionnaire
 * @version v0.3
 */
export default class QuestionnairesidQuestionnaire {
  /**
   * Constructs a new <code>QuestionnairesidQuestionnaire</code>.
   * @alias module:model/QuestionnairesidQuestionnaire
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>QuestionnairesidQuestionnaire</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/QuestionnairesidQuestionnaire} obj Optional instance to populate.
   * @return {module:model/QuestionnairesidQuestionnaire} The populated <code>QuestionnairesidQuestionnaire</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new QuestionnairesidQuestionnaire();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('is_public'))
        obj.isPublic = ApiClient.convertToType(data['is_public'], 'Boolean');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('questions_attributes'))
        obj.questionsAttributes = ApiClient.convertToType(data['questions_attributes'], [QuestionnairesidQuestionnaireQuestionsAttributes]);
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
    }
    return obj;
  }
}

/**
 * Title of the questionnaire
 * @member {String} title
 */
QuestionnairesidQuestionnaire.prototype.title = undefined;

/**
 * Determines whether the survey can be accessed by a user who is not a Capable Health patient
 * @member {Boolean} isPublic
 */
QuestionnairesidQuestionnaire.prototype.isPublic = undefined;

/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
QuestionnairesidQuestionnaire.StatusEnum = {
  /**
   * value: "active"
   * @const
   */
  active: "active",

  /**
   * value: "archived"
   * @const
   */
  archived: "archived"
};
/**
 * @member {module:model/QuestionnairesidQuestionnaire.StatusEnum} status
 */
QuestionnairesidQuestionnaire.prototype.status = undefined;

/**
 * @member {Array.<module:model/QuestionnairesidQuestionnaireQuestionsAttributes>} questionsAttributes
 */
QuestionnairesidQuestionnaire.prototype.questionsAttributes = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
QuestionnairesidQuestionnaire.prototype.tagList = undefined;

